import type { TextSize } from '../../global-types/Content';

type ParagraphProps = {
  text: string;
  size?: TextSize;
  color?: string;
  bold?: boolean;
};

function Paragraph({ text, size, color, bold }: ParagraphProps) {
  let textSize: string;
  switch (size) {
    case 'x-small':
      textSize = 'x-small';
      break;
    case 'small':
      textSize = 'small';
      break;
    case 'medium':
      textSize = 'medium';
      break;
    case 'large':
      textSize = 'large';
      break;
    case 'x-large':
      textSize = 'x-large';
      break;
    default:
      textSize = 'medium';
      break;
  }
  return (
    <p className={`if typography pb-8 ui ${bold ? 'weight-bold' : ''} ${textSize} ${color ? color : ''}`}>{text}</p>
  );
}

export default Paragraph;
